import uuid from 'uuid-random';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import { TIME_PERIODS, LIMIT_TYPES, ALL_LIMIT_TYPE } from './constants';

export const parseLimits = (data = { data: { limits: [] } }) =>
    data.data.limits.map(limit => ({ id: uuid(), ...limit }));

export const parseEnabledLimitTypes = (data) => {
    const enabledTypes = [LIMIT_TYPES.DEPOSIT, LIMIT_TYPES.SELF_EXCLUSION];
    const {
        timeoutConfigurationItems, betLimitConfigurationItems, lossLimitConfigurationItems,
        loginLimitsConfigurationItems, sessionTimerConfigurationItems, autoWithdrawConfigurationItems,
        realityCheckConfigurationItems, productLimitConfigurationItems, singleBetLimitConfigurationItems
    } = data;

    timeoutConfigurationItems[0]?.availablePeriods.length
        && enabledTypes.push(LIMIT_TYPES.TIMEOUT);

    sessionTimerConfigurationItems[0]?.availableTimerPeriods.length
        && enabledTypes.push(LIMIT_TYPES.SESSION_TIMER);

    betLimitConfigurationItems[0]?.betLimitEnabled
        && enabledTypes.push(LIMIT_TYPES.BET);

    lossLimitConfigurationItems[0]?.lossLimitEnabled
        && enabledTypes.push(LIMIT_TYPES.LOSS);

    autoWithdrawConfigurationItems[0]?.enabled
        && enabledTypes.push(LIMIT_TYPES.WITHDRAW, LIMIT_TYPES.MIN_BALANCE);

    realityCheckConfigurationItems[0]?.realityCheckEnabled
        && enabledTypes.push(LIMIT_TYPES.REALITY_CHECK);

    singleBetLimitConfigurationItems[0]?.enabled
        && enabledTypes.push(LIMIT_TYPES.SINGLE_BET_LIMIT);

    if (loginLimitsConfigurationItems[0]) {
        const {
            dailyLoginTime,
            weeklyLoginTime,
            monthlyLoginTime,
            monthlyLoginCount
        } = loginLimitsConfigurationItems[0];

        monthlyLoginCount && enabledTypes.push(LIMIT_TYPES.LOGIN_AMOUNT);

        if (dailyLoginTime || weeklyLoginTime || monthlyLoginTime) {
            enabledTypes.push(LIMIT_TYPES.LOGIN_PERIOD);
        }
    }

    if (productLimitConfigurationItems?.length) {
        const isProductLossEnabled = productLimitConfigurationItems.find(item => item.type === 7)?.limitEnabled;
        const isProductBetEnabled = productLimitConfigurationItems.find(item => item.type === 6)?.limitEnabled;

        isProductLossEnabled && enabledTypes.push(LIMIT_TYPES.PRODUCT_LOSS);
        isProductBetEnabled && enabledTypes.push(LIMIT_TYPES.PRODUCT_BET);
    }

    return enabledTypes.map(type => ({ type }));
};

export const getStartDate = (startDateValue) => {
    const currentDate = new Date();
    const date = new Date(currentDate.setDate(currentDate.getDate() - startDateValue));

    return getDateForIms(date);
};

export const getInitialFromDate = () => {
    const currentDate = new Date();

    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 1, 0, 0, 0, 0);
};

export const intoDate = (date) => typeof date === 'number' ? new Date(date) : date;

export const getPeriodOptions = (t) => TIME_PERIODS.map(({ value, label }) => ({ value, label: t(label) }));

export const getLimitTypeOptions = (options, t) => [
    { value: ALL_LIMIT_TYPE, label: t('filter.limitType.all') },
    ...options.map(({ type }) => ({ value: type, label: t(`filter.limitType.${type}`) }))
];

export const formatLoginLimit = (minutes, t) => {
    const loginLimit = {
        dd: Math.floor(minutes / 24 / 60),
        hh: Math.floor(minutes / 60 % 24),
        mm: minutes % 60
    };
    const { dd, hh, mm } = loginLimit;
    const timeOnly = `${hh}${t('table.limit.date.hh')} ${mm}${t('table.limit.date.mm')}`;

    if (dd) {
        return `${dd}${t('table.limit.date.dd')} ${timeOnly}`;
    }

    return timeOnly;
};

export const getDescriptions = (descriptions) => descriptions.map(description => ({
    ...description,
    ...description.type === LIMIT_TYPES.LOGIN_AMOUNT ? { period: 'monthly' } : {}
}));

